
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.811 11.042a.5.5 0 01.09.992l-.09.008H2.734c-.617 0-1.125.47-1.186 1.07l-.006.122v7.616c0 .617.47 1.125 1.07 1.186l.122.006h7.3a.5.5 0 01.09.992l-.09.008h-7.3a2.192 2.192 0 01-2.186-2.036l-.006-.156v-7.616c0-1.158.898-2.106 2.036-2.186l.156-.006h7.077zM21.308 2.5c1.21 0 2.192.982 2.192 2.192V20.77c0 1.211-.982 2.193-2.192 2.193h-7.616a2.192 2.192 0 01-2.192-2.193V4.692c0-1.21.982-2.192 2.192-2.192zM22.5 19.153h-10v1.616c0 .618.47 1.125 1.07 1.186l.122.007h7.616c.658 0 1.192-.534 1.192-1.193v-1.616zM17.288 20l.094.007a.635.635 0 11-.187 0l.093-.007zM3.115 14.4a.5.5 0 01.492.41l.008.09v4.23a.5.5 0 01-.992.09l-.008-.09V14.9a.5.5 0 01.5-.5zM21.308 3.5h-7.616c-.658 0-1.192.534-1.192 1.192v13.461h10V4.693c0-.618-.47-1.126-1.07-1.187l-.122-.006zM7.237 1.56l.075.05 2.5 1.997c.022.018.036.031.05.045l.018.02a.497.497 0 01.111.419l-.004.02a.492.492 0 01-.083.182l-.032.038-.056.053-.003.004-2.5 2.002-.076.05a.5.5 0 01-.565-.062l-.062-.065-.05-.076a.5.5 0 01.062-.565l.066-.062 1.536-1.23C5.257 4.377 2.276 6.353 1.48 9.135a.5.5 0 01-.962-.274c.897-3.139 4.117-5.354 7.414-5.476L6.688 2.39l-.065-.063a.5.5 0 01.614-.768zM19.615 4.5a.5.5 0 01.09.992l-.09.008h-4.23a.5.5 0 01-.09-.992l.09-.008h4.23z","fill":"#9A7C5D","fill-rule":"evenodd"}})])
          )
        }
      }
    